import { adminAPIService } from './index'

const route = 'editorials'

export default {
  getList(page = 1, size = 20, title, slug) {
    const params = {
      page,
      size,
      title,
      slug
    }

    return adminAPIService({
      url: route,
      method: 'get',
      params,
    })
  },
  getDetail(id) {
    return adminAPIService({
      url: `${route}/${id}`,
      method: 'get',
    })
  },
  createNew(editorialDetail) {
    const body = `json=${encodeURIComponent(JSON.stringify(editorialDetail))}`
    return adminAPIService({
      url: route,
      method: 'post',
      data: body,
    })
  },
  updateDetail(editorialDetail, id) {
    const body = `json=${encodeURIComponent(JSON.stringify(editorialDetail))}`
    return adminAPIService({
      url: `${route}/${id}`,
      method: 'post',
      data: body,
    })
  },
  toggleEnableEditorial(id, enabled) {
    const body = `json=${JSON.stringify({ enabled })}`
    return adminAPIService({
      url: `${route}/${id}`,
      method: 'post',
      data: body,
    })
  },
  toggleListEditorial(id, listed) {
    const body = `json=${JSON.stringify({ listed })}`
    return adminAPIService({
      url: `${route}/${id}`,
      method: 'post',
      data: body,
    })
  },
  duplicateEditorial(id) {
    return adminAPIService({
      url: `${route}/${id}/duplicate`,
      method: 'post',
    })
  },
  getCategoryList() {
    const params = {
    }

    return adminAPIService({
      url: `${route}/categories`,
      method: 'get',
      params,
    })
  },
}
